import React from 'react';
import SaenggibuSuggestionCard from './SaenggibuSuggestionCard';
import { canShowSaenggibuSuggestionCard } from '../../utils/saenggibuSuggestion';

const SaenggibuSuggestionMount = ({
  recordId,
  isGenerating = false,
  isAnonymous = false,
  suggestionApi,
  onAction,
}) => {
  const suggestion = suggestionApi?.suggestion || null;
  const result = suggestionApi?.result || null;
  if (!canShowSaenggibuSuggestionCard({
    recordId,
    isGenerating,
    isAnonymous,
    suggestion,
  }) || result) {
    return null;
  }

  return (
    <SaenggibuSuggestionCard
      suggestion={suggestion}
      result={result}
      busy={Boolean(suggestionApi?.busy)}
      onAction={onAction}
    />
  );
};

export default SaenggibuSuggestionMount;
